// extracted by mini-css-extract-plugin
module.exports = {"stickyElement":"styles_stickyElement__rHG7u","stickyElementStuck":"styles_stickyElementStuck__PIqMW"};